/* ============================================
   NIMBA FOODS — Klaviyo Email Subscribe Helper
   Uses Klaviyo Client Subscriptions API (public)
   ============================================ */

function klaviyoSubscribe(email, signupSource, properties) {
  if (!email) return;
  const profileProperties = Object.assign(
    { signup_source: signupSource || 'website' },
    properties || {}
  );
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Ys2bwY', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: signupSource || 'website',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: profileProperties
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: 'RKYbsp' }
          }
        }
      }
    })
  }).catch(function () { /* fire-and-forget */ });
}
